var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('a',{staticClass:"content",attrs:{"href":_vm.url,"target":"_blank"}},[_c('chevron-right'),_c('chevron-right'),_c('h2',[_vm._v(_vm._s(_vm.text))]),_c('chevron-left'),_c('chevron-left')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }